module.exports = __webpack_public_path__ + "static/siding-c65a3f86156bfdb496082f691c70114b.jpg";